import { useQuery } from '@tanstack/react-query'

import { clients } from '@digital-commerce/shared-utils'

import createDigitalCommerceCartClient from '../clients/bff'

const client = createDigitalCommerceCartClient(clients.bff)

const useFeatureFlags = () => {
  return useQuery({ queryKey: ['/feature-flags'], queryFn: client.getFeatureFlags })
}

export default useFeatureFlags
